import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import {
  MxBrowserStorageService,
  MxIdentityService,
  MxStorageType,
} from '../services';

@Injectable()
export class MxServerErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private identityService: MxIdentityService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      // retry(1),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          if (error.error.errorCode === 'EXPIRED_TOKEN') {
            MxBrowserStorageService.set(
              MxStorageType.Local,
              error.error.errorCode,
              error.error
            );
          }
          this.identityService.logout(true);
          return throwError(error.error);
        } else if (error.status === 403) {
          this.router.navigate(['pages', 'access-denied']);
          return throwError('Navigate to access-denied');
        } else if (error.status === 404) {
          this.router.navigate(['pages', 'not-found']);
          return throwError('Navigate to not-found');
        } else if ([400, 401, 500].includes(error.status)) {
          return throwError(error);
        } else {
          this.router.navigate(['pages', 'error']);
          return throwError('Navigate to error');
        }
      })
    );
  }
}
